import { createApolloClient } from "@dreebit-registry/vsm-microservice-components";
import keycloak from "../keycloak";
import { typePolicies } from "./typePolicies";

export const client = createApolloClient({
    keycloak,
    clientName: "InstalledBase",
    typePolicies,
});
